import { useEffect, useState } from 'react';
import { dataForDayOffTablesCancel, sortingDate } from 'shared/helpers/utils';
import { Badge, Skeleton } from 'antd';
import { RequestsSearch, TColumns } from 'shared/types/types';
import { usePullSort } from 'shared/hooks';
import { SortCondition } from 'shared/enums';

import { SearchKeysNews } from 'shared/enums/news';
import { TablePull } from 'features/tables';
import { ONE_MINUTE } from 'shared/constants';
import {
  DayOffsStatusesMap,
  DayOffsStatusTypesMap,
  DayOffTabs,
  TPreparedDayOffPublicated,
} from 'shared/types/dayoff.types';
import { useLazyDayoffsCanceledQuery } from 'app/services/edpApiV1/cancelDayoff';
import { useAppSelector } from 'app/store';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import style from './index.module.scss';

export const DayOffArchive = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const [dataDayOffs, setDataDayOffs] = useState<TPreparedDayOffPublicated[] | []>([]);
  const [sortInfo, sortTrigger] = usePullSort();
  const sortOption = sortInfo.value && sortInfo.value === SortCondition.ASCEND ? SortCondition.ASC : SortCondition.DESC;
  const [search, setSearch] = useState<RequestsSearch>({ byId: undefined, fio: undefined });
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  // Добавляем пуллинг обновления списка и обновляем индикаторы через хук useIndicators
  const [getDayOffs, { data, isLoading }] = useLazyDayoffsCanceledQuery({
    pollingInterval: ONE_MINUTE,
  });

  useEffect(() => {
    getDayOffs({
      type: DayOffTabs.myArchive,
      size: currentSize,
      page: currentPage,
      order: sortInfo.value ? sortOption : undefined,
      allAvailableOrganizations,
      ...search,
    });
  }, [currentPage, currentSize, getDayOffs, search, sortInfo.value, sortOption, allAvailableOrganizations]);

  useEffect(() => {
    if (data) {
      const dataTable = dataForDayOffTablesCancel(data?.data || []);
      if (dataTable) {
        setDataDayOffs(dataTable);
      }
    }
  }, [data]);

  const onSearch = (data: string, key: SearchKeysNews) => {
    if (key === SearchKeysNews.SEARCH_ID) {
      setSearch({ fio: undefined, byId: data ? data : undefined });
    } else if (key === SearchKeysNews.SEARCH_NAME) {
      setSearch({ byId: undefined, fio: data ? data : undefined });
    } else {
      setSearch({ [key]: data ? data : undefined });
    }
  };

  const columns: TColumns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
      width: 100,
    },
    {
      title: 'Дата',
      dataIndex: 'created',
      key: 'created',
      sortDirections: [SortCondition.ASCEND, SortCondition.DESCEND],
      sorter: (a, b) => sortingDate(a.created, b.created),
      onHeaderCell: () => ({
        onClick: () => sortTrigger(),
      }),
    },
    {
      title: 'ФИО',
      dataIndex: 'fio',
      key: 'fio',
    },

    {
      title: 'Дата начала',
      dataIndex: 'dayOffDate',
      key: 'dayOffDate',
    },
    {
      title: 'Дата окончания',
      dataIndex: 'endedAt',
      key: 'endedAt',
    },

    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => (
        <>
          <span>
            <Badge className={style.badge} status={DayOffsStatusTypesMap[status]} />
            {DayOffsStatusesMap[status]}
          </span>
          <br />
          {/* {!status.isSupervisorApproved && <SuperviserApproveMarker text="Не согласовано руководителем" />} */}
        </>
      ),
    },
  ];

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <>
          {dataDayOffs && columns && (
            <TablePull
              dataSource={dataDayOffs}
              columns={columns}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              currentSize={currentSize}
              setCurrentSize={setCurrentSize}
              total={data?.pagination?.total}
              onSearch={onSearch}
            />
          )}
        </>
      )}
    </>
  );
};
